import { useMemo } from 'react';
import { AircraftIcon, CarGroundIcon } from '@icons';
import { TransportType } from '@lp/features/RoutePlanner/components/TransportType';
import { AviaLegTypes, GroundLegTypes, RouteLegTypeEnum } from '@/api/apis/route';
import { convertMsToTimeString, formatDateTimeStringToTimeZone, getTimeDifference } from '@/utils/helpers';
import { isBaseGroundLegType, isGroundTripLegType } from '@/utils/route';
import { TmdxAviaInfo } from './TmdxAviaInfo';

type LegDateTimeProps = {
  leg: AviaLegTypes | GroundLegTypes;
};

export const LegDateTime = ({ leg }: LegDateTimeProps) => {
  const startTime = formatDateTimeStringToTimeZone(leg.departureTime, leg.departureLocalTimezone, 'HH:mm');
  const endTime = formatDateTimeStringToTimeZone(leg.arrivalTime, leg.arrivalLocalTimezone, 'HH:mm');

  const timeDuration = useMemo(() => {
    const timeDifference = getTimeDifference(new Date(leg.departureTime), new Date(leg.arrivalTime));
    return convertMsToTimeString(timeDifference.MILLISECONDS);
  }, [leg]);

  const isBaseGround = isBaseGroundLegType(leg);
  const isGroundTripLeg = isGroundTripLegType(leg);
  const isGround = isBaseGround || isGroundTripLeg;

  const icon = isGround ? <CarGroundIcon width={24} height={24} /> : <AircraftIcon width={24} height={24} />;

  const renderTransportInfo = () => {
    switch (leg.legType) {
      case RouteLegTypeEnum.TmdxJetAviaLeg:
        return <TmdxAviaInfo leg={leg} />;
      default:
        return icon;
    }
  };

  return (
    <div className="flex flex-row justify-between items-center border-b border-base-55 pb-3 gap-4">
      <div className="flex items-center gap-3">
        <div className="flex gap-1 items-center">
          <TransportType legType={leg.legType} />
          {renderTransportInfo()}
        </div>
        <span className="w-max text-m-m text-base-5">
          {startTime} - {endTime}
        </span>
      </div>
      <span className="text-m-sb text-base-5">{timeDuration}</span>
    </div>
  );
};
